import { SVGProps } from 'react'

export const FRIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16816_21469)">
      <path
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#F0F0F0"
      />
      <path
        d="M47.9999 23.9999C47.9999 13.6807 41.4869 4.88371 32.3477 1.49268V46.5072C41.4869 43.1161 47.9999 34.319 47.9999 23.9999Z"
        fill="#D80027"
      />
      <path
        d="M0.000976562 24.0014C0.000976562 34.3205 6.51407 43.1175 15.6532 46.5086V1.49414C6.51407 4.88517 0.000976562 13.6822 0.000976562 24.0014Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_16816_21469">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
